import { placeholderOverrideValues } from '@components/TableV2/helpers/constants';
import { missingValuePlaceholder } from '@utils/constants';

export const isMissingValuePlaceholder = (value: string) =>
  placeholderOverrideValues.includes(value) ? missingValuePlaceholder : value;
